import { c as _c } from "react/compiler-runtime";
import { IcoBuilding24 } from '@onefootprint/icons';
import type { Iso3166TwoDigitCountryCode } from '@onefootprint/request-types';
import { Form } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import type { CardFormData } from '../types';
type CountryAndZipSectionProps = {
  collectsCountry: boolean;
  collectsZip: boolean;
  country: Iso3166TwoDigitCountryCode;
  clearServerError: (fieldName: keyof CardFormData) => void;
};
const CountryAndZipSection = t0 => {
  const $ = _c(19);
  const {
    collectsCountry,
    collectsZip,
    country,
    clearServerError
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "collectCardData"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("idv2", t1);
  if (!collectsCountry && !collectsZip) {
    return null;
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <IcoBuilding24 color="primary" />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t) {
    t3 = t(_temp);
    $[2] = t;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = <div className="flex gap-1 items-center">{t2}<div className="text-primary text-label-2">{t3}</div></div>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== clearServerError || $[7] !== collectsCountry || $[8] !== t) {
    t5 = collectsCountry && <Form.Country label={t(_temp2)} name="country" data-dd-privacy="mask" rules={{
      required: t(_temp3)
    }} placeholder={t(_temp4)} onChange={() => clearServerError("country")} />;
    $[6] = clearServerError;
    $[7] = collectsCountry;
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== clearServerError || $[11] !== collectsZip || $[12] !== country || $[13] !== t) {
    t6 = collectsZip && <Form.Zip name="zip" label={t(_temp5)} country={country} placeholder={t(_temp6)} rules={{
      required: t(_temp7),
      onChange: () => clearServerError("zip")
    }} />;
    $[10] = clearServerError;
    $[11] = collectsZip;
    $[12] = country;
    $[13] = t;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t4 || $[16] !== t5 || $[17] !== t6) {
    t7 = <section className="flex flex-col gap-4 border border-tertiary rounded p-4">{t4}{t5}{t6}</section>;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  return t7;
};
export default CountryAndZipSection;
function _temp($) {
  return $.form.billingInformation;
}
function _temp2($_0) {
  return $_0.form.country.label;
}
function _temp3($_1) {
  return $_1.form.country.errors.required;
}
function _temp4($_2) {
  return $_2.form.country.placeholder;
}
function _temp5($_3) {
  return $_3.form.zip.label;
}
function _temp6($_4) {
  return $_4.form.zip.placeholder;
}
function _temp7($_5) {
  return $_5.form.zip.errors.required;
}